import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import Loader from './Loader.js';
import './RodadaSelect.css';

export default function RodadaSelect(props) {
	const max_rodada = parseInt(props.max_rodada);
	const last_rodada = parseInt(props.last_rodada);

	const [rodada, setRodada] = useState(last_rodada);
	const [showRodadaPopup, setShowRodadaPopup] = useState(false);

	const popupRef = useRef(null);
	const selectedRef = useRef(null);

	useEffect(() => {
		if (popupRef.current && showRodadaPopup) {
			popupRef.current.scrollTop = selectedRef.current.offsetTop - (popupRef.current.clientHeight / 2);
		}
	}, [ showRodadaPopup ]);

	// Fora do rodada correta? Volta para a ultima ativa
	if (rodada === null) {
		setRodada(last_rodada || 1);
		return <Loader text="RodadaSelect1"/>;
	}
	if (rodada > max_rodada && rodada > 1) {
		setRodada(max_rodada);
		return <Loader text="RodadaSelect2"/>;
	}
	const prevRodada = () => setRodada(Math.max(1, rodada-1));
	const nextRodada = () => setRodada(Math.min(max_rodada, rodada+1));

	const getNomeRodada = function(rodada) {
		let nomeRodada = rodada + "ª rodada";

		if (props.ida_volta) {
			if (rodada === 1) {
				nomeRodada = "Ida";
			} else if (rodada === 2) {
				nomeRodada = "Volta";
			}
		}
		return nomeRodada;
	}

	return (
		<>
			{ max_rodada > 1 ?
				( <>
					<div className={"row title-rodada e0" + (rodada === 1 ? " first-selected" : "") + (rodada === max_rodada ? " last-selected" : "")}>
						<div className="button e0 left" onClick={prevRodada}><FontAwesomeIcon icon={fa.faChevronLeft} /></div>
						<div className="e100 nome-rodada" onClick={(e) => { setShowRodadaPopup(!showRodadaPopup); e.stopPropagation(); }}>
							<div ref={popupRef} data-show={showRodadaPopup} className="select-rodada">
								<div>
								{[ ...Array(max_rodada).keys() ].map((e) => {
									const thisRodada = e+1;
									const nomeRodada = getNomeRodada(thisRodada);

									return (
										<div
											key={thisRodada}
											ref={rodada === thisRodada ? selectedRef : null}
											className={(rodada === thisRodada ? "selected" : "") + (thisRodada > last_rodada && props.markInactive ? " inactive" : "")}
											onClick={(e) => {
												setShowRodadaPopup(false);
												if (thisRodada <= last_rodada || !props.markInactive) {
													setRodada(thisRodada);
												}
												e.stopPropagation();
											}}
											>
											{nomeRodada}
										</div>
									);
								})}
								</div>
							</div>
							{getNomeRodada(rodada)}
							<div className="select-icon">
								<FontAwesomeIcon icon={fa.faChevronDown}/>
							</div>
						</div>
						<div className="button e0 right" onClick={nextRodada}><FontAwesomeIcon icon={fa.faChevronRight} /></div>
					</div>
					<div data-show={showRodadaPopup} className="select-rodada-blackout" onClick={(e) => { setShowRodadaPopup(false); e.stopPropagation();}}></div>
				</> )
			:
				null
			}
			{props.render({rodada})}
		</>
	);
}
